// Functionality of additional product adding into main product.
document.addEventListener('DOMContentLoaded', function() {
    const additionalProducts = document.querySelectorAll('.custom-additional-product');
    if (additionalProducts.length > 0) {
        additionalProducts.forEach(additionalProduct => {
            const ProductInput = additionalProduct?.querySelector('.pro_input input');
            const additionalProButton = additionalProduct?.querySelector('.pro_btn')?.querySelector('button');
            if (ProductInput) {
                ProductInput.addEventListener('change', handleAdditionalProductUpdate);
            }
            if (additionalProButton) {
                additionalProButton.addEventListener('click', handleCustomAddToCartClick);
            }
        });
    }
});

async function handleCustomAddToCartClick(e) {
  const target = e.target;
  const mainAddToCartBtn = target?.closest('.product__info-wrapper').querySelector('product-form')?.querySelector('button[name="add"]');
  const productForm = mainAddToCartBtn.closest("product-form");
  await handleAdditionalProductAddToCart(productForm);
  mainAddToCartBtn.click();
}

async function handleAdditionalProductAddToCart(productForm) {
    const variantId = productForm.getAttribute("data-additional-product");
    if (!variantId) {
        return;
    }
    const formData = { items: [{ id: variantId, quantity: 1 }], sections: productForm.cart.getSectionsToRender().map((section) => section.id), sections_url: window.location.pathname };
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(formData);
    await fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      console.log(response);
      // productForm.cart.renderContents(response);
    });

    // const fetchUrl = isChecked ? 'cart/add.js' : 'cart/update.js';
    // fetch(window.Shopify.routes.root + fetchUrl, {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify(isChecked ? formData : {
    //             updates: {
    //                 [variantId]: 0
    //             }
    //         })
    //     }).then(response => response.json())
    //     .then(data => {
    //         if (!isChecked) {
    //             publish(PUB_SUB_EVENTS.cartUpdate, { variantId, data });
    //         }
    //     }).catch(error => {
    //         console.error('Error:', error);
    //     });
}

document.addEventListener('DOMContentLoaded', function() {
  const mainProductPriceElement = document.querySelector('.custom_main_price .variant-total-price');
  let mainProductPrice = 0;
  
  if (mainProductPriceElement) {
    const originalPriceText = mainProductPriceElement.textContent;
    mainProductPrice = parseFloat(originalPriceText.replace(/[^\d.,]/g, '').replace(',', '.'));
  }
  
  function updateTotalPrice() {
    if (!mainProductPriceElement) return;  
    let totalPrice = mainProductPrice;
    const checkedCheckboxes = document.querySelectorAll('.pro_input input[type="checkbox"]:checked');
    checkedCheckboxes.forEach(checkbox => {
      const proInputDiv = checkbox.closest('.pro_input');
      const variantSelector = proInputDiv.querySelector('.variant-selector');
      if (variantSelector) {
        const selectedOption = variantSelector.options[variantSelector.selectedIndex];
        if (selectedOption) {
          const variantPriceText = selectedOption.getAttribute('data-variant-price');
          const variantPrice = parseFloat(variantPriceText.replace(/[^\d.,]/g, '').replace(',', '.'));
          if (!isNaN(variantPrice)) { 
            totalPrice += variantPrice;
          }
        }
      } 
    });
    
    const currencySymbol = mainProductPriceElement.textContent.match(/[^\d.,\s]+$/)?.[0] || '€';
    const formattedPrice = totalPrice.toFixed(2).replace('.', ',');
    mainProductPriceElement.textContent = formattedPrice + ' ' + currencySymbol;
  }
  
  function updateVariantPriceDisplay(proInputDiv) {
    const variantSelector = proInputDiv.querySelector('.variant-selector');
    if (!variantSelector) return;
    const selectedOption = variantSelector.options[variantSelector.selectedIndex];
    if (!selectedOption) return;
    const variantPrice = selectedOption.getAttribute('data-variant-price');
    if (!variantPrice) return;
    const priceWrappers = proInputDiv.querySelectorAll('.variant-price-wrapper');
    priceWrappers.forEach(wrapper => {
      wrapper.textContent = variantPrice;
    });
  }
  
  document.querySelectorAll('.variant-selector').forEach(selector => {
    selector.addEventListener('change', function(e) {
      const proInputDiv = this.closest('.pro_input');
      updateVariantPriceDisplay(proInputDiv);
      const checkbox = proInputDiv.querySelector('input[type="checkbox"]');
      if (checkbox && checkbox.checked) {
        const event = new Event('change', { bubbles: true });
        checkbox.dispatchEvent(event);
      }
    });
  });
  
  document.querySelectorAll('.pro_input input[type="checkbox"]').forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      updateTotalPrice();
    });
  });
  
  setTimeout(() => {
    document.querySelectorAll('.pro_input').forEach(proInputDiv => {
      updateVariantPriceDisplay(proInputDiv);
    });
    updateTotalPrice();
  }, 100);
});

const additionalVariantSelector = document.querySelector("select.variant-selector");

if (additionalVariantSelector) {
  additionalVariantSelector.addEventListener("change", function (e) {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedPrice = parseFloat(
      selectedOption.dataset.variantPrice.replace(/\./g, "").replace(",", ".").replace(/[^\d.-]/g, "")
    );
    const hiddenInput = document.querySelector(".additional_info");
    const mainPrice = parseFloat(
      hiddenInput.getAttribute("data-main-product-price").replace(/\./g, "").replace(",", ".").replace(/[^\d.-]/g, "")
    );
    const formWrapper = document.querySelector("product-form.product-form");
    hiddenInput.dataset.additionalProductPrice = selectedPrice;
    const selectedVariantId = selectedOption.dataset.variantId;
    formWrapper.dataset.additionalProduct = selectedVariantId;
    console.log('Legacy handler: Set data-additional-product to:', selectedVariantId, 'for variant:', selectedOption.textContent);

    const productSection = e.target.closest("section");
    const checkbox = productSection?.querySelector(".pro_input input");
    const customPrice = productSection?.querySelector(".custom_main_price");

    if (checkbox && customPrice) {
      let totalPrice = mainPrice;
      if (checkbox.checked) {
        totalPrice = mainPrice + selectedPrice;
      }
      const formattedPrice = totalPrice.toFixed(2).replace('.', ',') + ' €';
      customPrice.textContent = "Summe: " + formattedPrice;
    }

    const priceWrappers = document.querySelectorAll(".variant-price-wrapper");
    priceWrappers.forEach(priceEl => {
      priceEl.textContent = selectedPrice.toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR",
      });
    });
  });
}

function handleAdditionalProductUpdate(e) {
    const target = e.target;
    const productSection = target.closest("section");
    const mainAdditionalProEle = target.closest('.custom-additional-product');
    const customPrice = mainAdditionalProEle?.querySelector('.custom_main_price');
    const additionalInfo = mainAdditionalProEle?.querySelector('.additional_info');
    const mainPrice = additionalInfo?.getAttribute('data-main-product-price');
    const totalPricetext = additionalInfo?.getAttribute('data-totalprice-text');
    const isChecked = target.checked;
    
    const proInputDiv = target.closest('.pro_input');
    const variantSelector = proInputDiv?.querySelector('.variant-selector');
    let selectedVariantPrice = 0;
    let selectedVariantId = null;
    
    if (variantSelector) {
      const selectedOption = variantSelector.options[variantSelector.selectedIndex];
      if (selectedOption) {
        const variantPriceText = selectedOption.getAttribute('data-variant-price');
        selectedVariantPrice = parseFloat(variantPriceText.replace(/[^\d.,]/g, '').replace(',', '.'));
        selectedVariantId = parseInt(selectedOption.getAttribute('data-variant-id'));
      }
    }
    
    const mainPriceValue = parseFloat(mainPrice.replace(/[^\d.,]/g, '').replace(',', '.'));
    const finalPrice = mainPriceValue + (isChecked ? selectedVariantPrice : 0);
    
    const formattedFinalPrice = finalPrice.toFixed(2).replace('.', ',') + ' €';
    const formattedMainPrice = mainPriceValue.toFixed(2).replace('.', ',') + ' €';
    
    customPrice.innerText = totalPricetext.replace('[price]', isChecked ? formattedFinalPrice : formattedMainPrice);
    
    if(productSection) {
      if(isChecked && selectedVariantId) {
        const productForm = productSection.querySelector("product-form");
        productForm.setAttribute("data-additional-product", selectedVariantId);
        console.log('Set data-additional-product to:', selectedVariantId, 'for variant:', selectedOption?.textContent);
      } else {
        const productForm = productSection.querySelector("product-form");
        productForm.removeAttribute("data-additional-product");
        console.log('Removed data-additional-product attribute');
      }
    }
}

async function updateExpandBtn(){  
  const readMoreBtn = document.querySelector('.read_more_less .read-more');
  const readLessBtn = document.querySelector('.read_more_less .read-less');
  if (readMoreBtn) {
      readMoreBtn.addEventListener('click', function() {
          const variantpickercover = document.querySelector('.pro_variant');
          variantpickercover.classList.add('showvariant');
          readMoreBtn.classList.add('hidden');
          readLessBtn.classList.remove('hidden');
      });
  }
  if (readLessBtn) {
      readLessBtn.addEventListener('click', function() {
          const variantpickercover = document.querySelector('.pro_variant');
          variantpickercover.classList.remove('showvariant');
          readLessBtn.classList.add('hidden');
          readMoreBtn.classList.remove('hidden');
      });
  }
}
document.addEventListener('DOMContentLoaded', updateExpandBtn);



$('.logos_slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    centerMode: false,
    responsive: [
    {
      breakpoint: 1199,
      settings: { 
      	slidesToShow: 3 
      }
    },
    {
      breakpoint: 820,
      settings: { 
      	slidesToShow: 3 
      }
    }, 
    {
	    breakpoint: 750,
	    settings: {
	        slidesToShow: 4
	    }
    }, 
    {
	    breakpoint: 570,
	    settings: {
	        slidesToShow: 3
	    }
    }, 
    {
	    breakpoint: 479,
	    settings: {
	        slidesToShow: 2
	    }
    }
    ]
});

  // document.addEventListener("DOMContentLoaded", function() {
  //   const slider = document.querySelector('#Slider-Gallery-{{ section.id }}');
  //   const slides = slider.querySelectorAll('.slider__slide');
  //   const prevButton = document.querySelector('.slider-button--prev');
  //   const nextButton = document.querySelector('.slider-button--next');
  //   const currentSlideElement = document.querySelector('.slider-counter--current');
  //   const totalSlidesElement = document.querySelector('.slider-counter--total');

  //   let currentIndex = 0;
  //   const totalSlides = slides.length;

  //   // Initialize the total slides counter
  //   totalSlidesElement.textContent = totalSlides;

  //   // Function to update the counter and slide visibility
  //   function updateSlider() {
  //     // Hide all slides
  //     slides.forEach(slide => slide.classList.remove('is-active'));
  //     // Show the current slide
  //     slides[currentIndex].classList.add('is-active');
  //     // Update the current slide counter
  //     currentSlideElement.textContent = currentIndex + 1;
  //   }

  //   // Function to move to the next slide
  //   function moveToNextSlide() {
  //     currentIndex = (currentIndex + 1) % totalSlides;  // Loop back to the first slide if we're at the last one
  //     updateSlider();
  //   }

  //   // Function to move to the previous slide
  //   function moveToPreviousSlide() {
  //     currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;  // Loop back to the last slide if we're at the first one
  //     updateSlider();
  //   }

  //   // Event listeners for the buttons
  //   nextButton.addEventListener('click', moveToNextSlide);
  //   prevButton.addEventListener('click', moveToPreviousSlide);

  //   // Initialize the first slide
  //   updateSlider();
  // });


// VIDEO POPUP JS START HERE 
document.addEventListener('DOMContentLoaded', function () {
  const videoBlocks = document.querySelectorAll('.custom-popup__video');

  videoBlocks.forEach(videoBlock => {
    const playButton = videoBlock.querySelector('.custom-popup__videobtn button');
    const videoPopup = videoBlock.querySelector('.custom-video__popup');
    const closeIcon = videoPopup.querySelector('.close-icon');
    const video = videoPopup.querySelector('video');

    // Open video popup
    playButton.addEventListener('click', function (e) {
      e.stopPropagation();
      videoPopup.classList.add('active');
      document.body.classList.add('video-popup--open');

      if (video) {
        video.play().catch(error => {
          console.log('Video play failed:', error);
        });
      }
    });

    // Close icon
    closeIcon.addEventListener('click', function (e) {
      e.stopPropagation();
      closeVideo();
    });

    // Outside click to close
    document.addEventListener('click', function (e) {
      const isClickInside = videoPopup.contains(e.target) || playButton.contains(e.target);
      if (!isClickInside && videoPopup.classList.contains('active')) {
        closeVideo();
      }
    });

    // Close video function
    function closeVideo() {
      videoPopup.classList.remove('active');
      document.body.classList.remove('video-popup--open');

      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    }
  });
});
